import script from "./Analytics.vue?vue&type=script&setup=true&lang=js"
export * from "./Analytics.vue?vue&type=script&setup=true&lang=js"

import "./Analytics.vue?vue&type=style&index=0&id=a145a9fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a145a9fe"]])

export default __exports__